import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a23cc52a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "measurement-fields" }

import { computed, ref, watch, PropType } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import { PropertyListingRoomResponse } from "@/types/properties/ai/PropertyListingRoomResponse";
import FieldValidationFreeTextArea from "@/components/ui/inputs/field-validation-free-text-area.vue";
import FieldValidationFreeTextbox from "@/components/ui/inputs/field-validation-free-textbox.vue";
import NumberBoxField from "@/components/ui/inputs/number-box-field.vue";
import { FieldSize } from "@/enums/system/FieldSize";


export default /*#__PURE__*/_defineComponent({
  __name: 'edit-property-listing-room',
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  room: {
    type: Object as PropType<PropertyListingRoomResponse>,
    required: true,
  },
},
  emits: ["update:modelValue", "modalClosed"],
  setup(__props, { emit }) {

const props = __props;




const displayCancelConfirmationModal = ref(false);
const keepingModalOpening = ref(false);
const saving = ref(false);
const editableData = ref<PropertyListingRoomResponse>({
  id: 0,
  name: "",
  description: "",
  length: 0,
  width: 0,
});

const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const onCancelClick = () => (showModal.value = false);

watch(
  () => showModal.value,
  () => {
    if (!showModal.value || keepingModalOpening.value) {
      return;
    }
    editableData.value = JSON.parse(JSON.stringify(props.room));
  },
);

watch(
  () => editableData.value,
  () => {
    displayCancelConfirmationModal.value =
      JSON.stringify(editableData.value) != JSON.stringify(props.room);
  },
  { deep: true },
);

const modalClosed = async () => {
  keepingModalOpening.value = false;
  displayCancelConfirmationModal.value = false;
  emit("modalClosed", false);
};

const cancelPromptDenied = () => {
  keepingModalOpening.value = true;
};

const onSaveClick = async () => {
  displayCancelConfirmationModal.value = false;
  emit("modalClosed", true, editableData.value);
  showModal.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalBase, {
    modelValue: showModal.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showModal).value = $event)),
    title: "Edit Room",
    onCancelPromptDenied: cancelPromptDenied,
    onModalClosed: modalClosed,
    showCloseConfirmationPrompt: displayCancelConfirmationModal.value
  }, {
    content: _withCtx(() => [
      _createVNode(FieldValidationFreeTextbox, {
        label: "Name",
        modelValue: editableData.value.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editableData.value.name) = $event)),
        height: "6rem"
      }, null, 8, ["modelValue"]),
      _createVNode(FieldValidationFreeTextArea, {
        label: "Description",
        modelValue: editableData.value.description,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editableData.value.description) = $event)),
        height: "6rem"
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_1, [
        (editableData.value.length !== null)
          ? (_openBlock(), _createBlock(NumberBoxField, {
              key: 0,
              label: "Length (m)",
              modelValue: editableData.value.length,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editableData.value.length) = $event)),
              min: 0,
              showSpinButtons: true,
              width: _unref(FieldSize).Small
            }, null, 8, ["modelValue", "width"]))
          : _createCommentVNode("", true),
        (editableData.value.width !== null)
          ? (_openBlock(), _createBlock(NumberBoxField, {
              key: 1,
              label: "Width (m)",
              modelValue: editableData.value.width,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((editableData.value.width) = $event)),
              min: 0,
              showSpinButtons: true,
              width: _unref(FieldSize).Small
            }, null, 8, ["modelValue", "width"]))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Save',
          onClick: () => {
            onSaveClick();
          },
          disabled: saving.value,
        }
      }, null, 8, ["options"]),
      _createVNode(_unref(DxToolbarItem), {
        widget: "dxButton",
        toolbar: "bottom",
        location: "after",
        options: {
          text: 'Cancel',
          onClick: () => {
            onCancelClick();
          },
          disabled: saving.value,
        }
      }, null, 8, ["options"])
    ]),
    _: 1
  }, 8, ["modelValue", "showCloseConfirmationPrompt"]))
}
}

})